import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { faArrowToRight } from '@fortawesome/pro-regular-svg-icons';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { useModal } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/Modal';
import useTourStore from '@monorepo/shared/src/graph/state/query-hooks/use-tour';
import { formatTourDataWithStepsViewed } from '@monorepo/shared/src/util/tour-data-utils';
import { FONT_GSS_FUTURA_BOOK } from '@monorepo/shared/src/themes/defaultTheme';
import ButtonWithFontAwesome from '@monorepo/shared/src/components/common/Buttons/ButtonWithFontAwesome';
import Config from '@monorepo/shared/src/config';
import useUserStore from '@monorepo/shared/src/graph/hooks/use-user';
import { TourName } from 'types';
const { REACT_APP_APP_NAME: appName } = process.env;

const t = (key: string, options?) => translate('modal', key, options);

const WelcomeModal = (props) => {
  const [, { closeModal }] = useModal();
  const [{ me }] = useUserStore();
  const [{ tourData, tourSteps }, { handleSaveTourSetting }] = useTourStore(
    TourName.WELCOME,
    appName
  );

  const navigate = useNavigate();
  const classes = useStyles();

  const goToTutorial = useCallback(async () => {
    await props.handleModalExit();
    navigate({
      pathname: '/tour/onboarding',
    });
  }, [props.handleModalExit]);

  const saveTourSetting = async (isSingleStep: boolean) => {
    if (tourData?.id && me?.id && tourSteps) {
      const data = formatTourDataWithStepsViewed({
        isEducator: true,
        tourId: tourData?.id,
        userOrStudentId: me?.id,
        tourSteps,
        isSingleStep,
      });
      data && (await handleSaveTourSetting(data));
    }
  };

  const skipTutorial = useCallback(async () => {
    await saveTourSetting(false);
    await props.handleModalExit();
    closeModal();
    navigate({
      pathname: '/',
    });
  }, [props.handleModalExit, tourData]);

  const getSrc = (uri) => `${Config.digitalAssetsUrl}${uri}`;

  return (
    <Box className={classes.modal}>
      <Box style={{ textAlign: 'center', padding: '60px 32px 24px' }}>
        <img className={classes.img} src={getSrc('/modals/images/mmaz-title.png')} />
        <Box style={{ textAlign: 'left', paddingTop: '30px' }}>
          <Typography className={classes.title} variant="h5">
            {t('welcome')}!
          </Typography>
          <Typography className={classes.subtitle}>{t('welcomeMessage')}</Typography>
        </Box>
        <Box style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '30px' }}>
          <ButtonWithFontAwesome
            onClick={skipTutorial}
            text={t('skipTutorialGetStarted')}
            startIcon={faArrowToRight}
            aria-label={t('skipTutorialGetStarted')}
            variant="outlined"
            color="primary"
            isInverted
          />{' '}
          <ButtonWithFontAwesome
            onClick={goToTutorial}
            text={t('viewTutorial')}
            startIcon={faArrowRight}
            aria-label={t('viewTutorial')}
            color="primary"
            variant="contained"
          />
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    flex: 1,
    backgroundColor: 'white',
    width: '600px',
    justifyContent: 'center',
  },
  img: {
    height: '250px',
    width: '450px',
  },
  title: {
    fontSize: '28px',
  },
  subtitle: {
    fontFamily: FONT_GSS_FUTURA_BOOK,
    fontSize: '16px',
    lineHeight: '24px',
  },
}));

export default WelcomeModal;
